export const sizes = {
  container: {
    md: "631px",
    lg: "1170px",
  },
  sidebar: {
    width: "368px",
  },
}
